export default {
  autoLocale: {
    switchTitle: '語言切換提示',
    switchMessage: '根據您所在地區，{target} 可能更適合目前瀏覽。是否進行切換？',
    switchConfirm: '切換為{target}',
    switchCancel: '保持目前'
  },
  Forex_Leverage: '外匯槓桿',
  Mac_desktop_version:'macOS 桌面版',
  System_requirements_Applicable_to_Mac_OS:'下載說明：適用於在 macOS 操作系統上安裝。',
  handerImgRightTips: [
    '臉部清晰展示',
    '身分證資訊完整呈現',
    '光線適宜',
    '背景純色',
  ],
  handerImgWrongTips: [
    '照片模糊，未對焦',
    '未清晰顯示細節',
    '面部遮擋問題',
    '身份证遮挡情况',
  ],
  field_cannot_be_empty_or_space: '字段不能為空或純空格',
  please_select_gender: '請選擇性別',
  please_select_nationality: '請選擇國籍',
  please_select_birthday: '請選擇出生日期',
  customersNum: '客戶數',
  Funds: '資金',
  Make_sure_the_photo_holding_your_ID_shows_your_face_your_ID_card_is_not_blocked_and_the_text_on_your_ID_card_is_clear: '確保手持證件照文件顯示您的臉部、身分證無遮蔽、身分證文字資訊清晰',
  No_handling_fee_is_charged_funds_are_withdrawn_to_your_own_MT4_account: '不收取手續費，資金提領到本人的MT4帳戶',
  Unlimited_amount: '不限額度',
  Transfer_to_MT4_account: '內轉MT4帳戶',
  Agent_Backstage: '代理後台',
  Convert_to_IB: '轉換為IB',
  Bank_Name: '銀行名稱',
  Annex_1: '附件1',
  Annex_2: '附件1',

  Return_to_old_version: '返回旧版',
  If_the_old_phone_cannot_be_used_please_contact_customer_service_to_request_modification: '*如當前手機號無法使用,請聯絡客服申訴修改',
  Current_mobile_phone_number: '當前手機號',
  Bonus_Account: '贈金帳戶',
  Redemption_Details: '兌換詳情',
  Contact_Number: '聯絡電話',
  Consignees_name: '收貨人姓名',
  Apply_for_redemption: '申請兌換',
  Order_Information: '訂單資訊',
  Please_fill_in_the_delivery_address: '請填寫收貨地址',
  Delivery_address: '收貨地址',
  Confirm_your_order: '確認訂單',
  Go_to_checkout: '去結算',
  Deduction_of_points: '扣除積分',
  My_Points: '我的積分',
  integral: '積分',
  Select_All: '全選',
  Cart: '購物車',
  add_to_the_cart: '加入購物車',
  Sales: '銷量',
  Sticky: '置頂',
  Start_Activation: '開始激活',
  Convenience_store_code_payment: '超市代碼支付',
  Card_punch: '卡打卡網銀',
  Channel_Type: '通道類型',
  direct_bank_connection: '銀行直連',
  scan_the_code_for_online_banking: '網銀掃碼',
  payment_bank: '支付銀行',
  Bank_Code: '銀行代碼',
  Player_Account: '付款帳戶',
  Supermarket_Code: '超市代碼',
  Account_Source: '帳戶來源',
  homePage: {
    currency: '幣種'
  },
  Usernames_are_not_allowed_to_contain_special_characters: '使用者名稱不允許含有特殊字符',
  Cent_accounts_allow_two_decimal_places_other_accounts_allow_one_decimal_place: 'Cent帳戶允許四位小數,其他帳戶允許一位小數',
  Cent_account_Stock_type_allows_two_decimal_places: 'Cent帳戶Stock類型允許兩位小數',
  Cent_account_Crypto_type_allows_two_decimal_places: 'Cent帳戶Crypto類型允許兩位小數',
  mt4DetailSetting: {
    leverTips: [
      '1、淨值<1000，外匯槓桿最高1000',
      '2、淨值<50000，外匯槓桿最高500',
      '3、淨值<100000，外匯槓桿最高400',
      '4、淨值<200000，外匯槓桿最高200',
      '5、淨值>=200000，外匯槓桿最高100',
    ],
  },
  faq: {
    Account_related: '帳戶相關',
    Agency_related: '代理相關',
    Transaction_related: '交易相關',
    Deposits_and_withdrawals: '存取款',
  },
  navBar: {
    Switch_to_customer: '切換為客戶',
    Switch_to_IB: '切換為代理',
  },
  menu: {
    Commission_details: '佣金明細',
  },
  customerHome: {
    Account_type_settings: '帳戶類型設定',
    MAM_master: 'MAM主',
    MAM_invest: 'MAM投資',

  },
  copyMaster: {
    No_trading_cycle_yet: '暫無交易週期',
    public: '公開',
    private: '不公開',
    Have_a_subscription_password: '訂閱密碼',
    No_subscription_password: '無訂閱密碼',
    No_subscription_yet: '暫無訂閱',
    Number_of_managed_accounts: '管理帳戶數',
    copy_pay: '訂閱支出',
    Please_subscribe_to_the_trader_first_and_then_view_the_details: '請先訂閱交易員,再查看詳情',
    view_the_details: '查看詳情',
    strategy: '策略',
    Not_active: '未生效',
    Subscribe_to_Trader: '訂閱交易員',
    key_words: '關鍵字',
    Subscription_time: '訂閱時間',
    Subscription_status: '訂閱狀態',
    pause: '暫停',
    No_active_subscription_yet: '暫無有效訂閱',
    Go_subscribe_now: '現在去訂閱',
    investment: '投資',
    MAM_status: 'MAM狀態',
    month: '個月',
  },
  bonusList: {
    Deposit_Activity_Account: '入金/活動帳戶',
    Deposit_account: '入金帳戶',
    Activity_Account: '活動帳戶',
    Deposit_Time: '入金时间',
    Cancel_bonus: '取消贈金',
    Apply_for_regularization: '申請轉正',
    Cancel_credit: '取消信用額',
    Passed_the_regularization: '轉正透過',
    Rejection_of_regularization: '轉正拒絕',

  },
  USD_account: '美元賬戶',
  Cent_Account: '美分賬戶',
  Bonus_management: '贈金管理',
  home: '首頁',
  My_profile: '我的檔案',
  funds_management: '資金管理',
  Download_Center: '下載中心',
  trading_software: '交易軟件',

  commission: '手續費',
  Only_jpg_png_images_can_be_uploaded_and_should_not_exceed_10MB: '只能上傳jpg/png圖片，且不超過10MB',
  integral_Shop: '積分商城',
  product_detail: '商品詳情',
  security_settings: '安全設置',
  Withdraw: '取出資金',
  funds_list: '資金流水',
  audit_list: '審核記錄',
  trader_Report: '交易報告',
  announcement: '公告消息',
  transaction_documents: '交易文件',
  Files: '文件資料',
  Agent_area: '代理專區',
  My_promotion: '我的推廣',
  My_customer: '我的客户',
  Symbol_Statistics: '品種統計',
  Commission_Statistics: '返傭統計',
  Performance_Statistics: '業績統計',
  Opening_lot: '開倉手數',
  Submission_for_review_successful: '提交審核成功',
  withdraw365: 'ChipPay(原OTC365)',
  Audit_Reject: '審核拒絕',
  Please_select_the_payment_account: '請選擇收款賬戶',
  // 新加的end
  The_format_of_uploaded_pictures_is_only_jpg_jpeg_png_bmp_tiff: '上傳圖片的格式僅限jpg/jpeg/png/bmp/tiff',

  // 新加的
  Price: '價格',
  Way: '方式',
  Activation_successful: '激活成功',
  Please_enter_the_activation_code: '請輸入激活碼',
  Active_account: '激活激活碼',
  Charged_when_the_trading_cycle_is_enabled_Performance_fees_are_as_shown_below_and_are_charged_at_settlement: '啟用交易週期時收取。表現費如下表，結算時收取。',
  my_subscription: '我的訂閲',
  and_activate: '並激活',
  Please_check_your_email: '請查看您的郵箱',
  Email_sent: '已發送郵件',
  recertification: '重新認證',
  Data_review_failed: '資料審核失敗',
  The_estimated_review_time_is_1_3_working_days_please_be_patient: '預計審核時間1-3個工作天，請耐心等待',
  To_verify_your_identity_information_please_prepare_your_ID_card_passport_and_ID_photo: '需核實身份資料，請準備好身份證 (護照) 證件照',
  Activation_email_sent: '已發送激活郵件',
  Demo_account_opened_successfully: '模擬帳戶開戶成功',
  Account_ratings_in_the_past_13_weeks: '近13週帳號評級',
  sign_out: '退出',
  View_rebate_rules: '查看返傭規則',
  Please_enter_the_sub_IB_level_name: '請輸入子IB等級名稱',
  Add_sub_IB_link: '新增子IB連結',
  Sub_IB_level_name: '子IB級別名稱',
  Unable_to_apply_due_to_incomplete_information_or_failed_review: '資料不全或審核未通過，無法申請',
  The_commission_cannot_be_exceeded: '不能超過可提佣金',
  Commission_can_be_withdrawn: '可提取佣金',
  Recommended_traders: '推薦交易員',
  My_MAM_account: '我的MAM帳戶',
  Search_trader_nickname: '搜索交易員暱稱',
  The_MAM_main_account_can_be_entrusted_to_manage_account_funds_and_independent_transactions_are_not_supported: 'MAM資管交易主賬戶，設置費率後開啓交易',
  MAM_investment_accounts_can_be_entrusted_to_manage_their_account_funds_and_charge_corresponding_fees_to_support_independent_transactions: '投資人委托主賬戶管理賬戶資金,不支持自主交易',
  Open_an_account: '開戶',
  MAM_main_account: 'MAM主賬戶',
  Use_CopyMaster_to_open_a_new_world_of_trading: '使用CopyMaster，開啟交易新世界',
  commission_contribution: '佣金貢獻',
  net_deposit: '淨入金',
  Add_direct_customer: '新增直客',
  Please_select_a_time: '請選擇時間',
  Net_withdrawals: '净入金',
  serial_number_num: '序號',
  Number_of_lots_to_close_position: '平倉手數',
  Number_of_trading_accounts: '交易賬號數',
  Sub_IB_name_ID: '子IB姓名/ID',
  Direct_customer_name_ID: '直客姓名/ID',
  Statistics_Time: '統計時間',
  Approval_Status: '審核狀態',
  total_commission: '總佣金',
  outside_commission: '外佣',
  inner_commission: '内佣',
  Attributed_Customer_IB: '歸屬客戶/IB',
  Source_of_rebate: '返傭來源',
  Commission_record: '返傭記錄',
  Belong_to_customers: '歸屬客戶',
  MT_group: 'MT組',
  Customer_Name_ID_Trading_Account: '客戶姓名/ID/交易帳戶',
  sub_IB: '子IB',
  Straight_off: '直客',
  Agent_level: '代理等級',
  Agent_name: '代理姓名',
  Agent_Name_ID: '代理姓名/ID',
  Direct_customer_list: '直客列表',
  Certification_status: '認證狀態',
  Customer_Name: '客戶姓名',
  Select_channel: '選擇渠道',
  Sub_IB_link: '子IB鏈接',
  Commission_is_available: '可提佣金',
  Customet_Equity: '客戶净值',
  System_Information: '系統消息',
  client_agreement: '客戶協議',
  privacy_agreement: '隱私協議',
  risk_agreement: '風險協議',
  Use_RS_APP_to_manage_your_account_and_make_quick_transactions: '使用Maxain APP，管理您的帳戶快速交易',
  Download_instructions_After_downloading_you_can_install_the_APK_through_your_mobile_phone: '下載說明：下載後可透過手機安裝APK',
  Download_instructions_iPhone_and_iPad_users_can_search_for_MetaTrader4_and_install_it_through_the_Apple_App_Store: '下載說明：iPhone和iPad用戶可以透過Apple App Store搜索MetaTrader4安裝。',
  iOS_mobile_version: 'IOS 移動端',
  System_requirements_Applicable_to_Windows_2008_7_8_10_operating_system: '系統需求：適用於Windows 2008/7/8/10作業系統',
  Windows_desktop_version: 'Windows 桌面版',
  Download_MetaTrader_4_and_experience_the_best_trading: '下載 MetaTrader 4，體驗最佳交易！',
  Take_profit_price: '止盈價格',
  Pending_order_price: '掛單價格',
  Order_time: '掛單時間',
  Trading_profit_and_loss: '交易盈虧',
  Inventory_fee: '庫存費',
  Stop_loss_price: '止損價格',
  Opening_price: '開倉價格',
  Lot: '手數',
  Trading_symbol: '交易品種',
  Opening_time: '開倉時間',
  Position: '持倉',
  Submitted_please_wait_for_review: '已提交，請等待審核',
  Payees_email: '收款人郵箱',
  Submitted_the_system_will_arrive_within_24_hours: '已提交，系統將在24小時內到賬',
  The_amount_that_can_be_withdrawn_is_0: '可提取金額為0',
  Confirm_transfer_out: '確認轉出',
  Transfer_another_persons_account: '轉他人帳戶',
  Transfer_to_self_held_account: '轉自持帳戶',
  Original: '原',
  At_least_greater_than_the_minimum_withdrawal_amount: '出金金額需大於最小金額{type}',
  withdrawal_amount_must_be_less_than_the_maximum_amount: '出金金額需小於最大金額{type}',
  At_least_greater_than_the_minimum_commission_amount: '出佣金額需大於最小金額{type}',
  commission_amount_must_be_less_than_the_maximum_amount: '出佣金額需小於最大金額{type}',
  Payment_amount: '打款金額',
  Amount_that_can_be_withdrawn: '可提取金額',
  Payee: '收款人',
  Complete_time: '完成時間',
  Balance_changes: '餘額變動',
  Trading_Wallet_Account: '交易/錢包帳戶',
  serial_number: '流水號',
  review_time: '審核時間',
  Operation_method: '操作方式',
  Operation_type: '操作類型',

  processing_time: '處理時間',
  account: '帳戶',
  active_account: '活動帳戶',

  area: '地區',
  Detailed_address_local_language: '詳細地址 (本地語言)',
  Upload_supporting_documents: '上傳證明文件',
  Make_sure_the_document_shows_your_full_name_full_address_and_the_time_it_was_issued_or_is_vali: '確保文件顯示您的完整姓名、完整地址和出具時間或有效期限。',
  certified_documents: '證明文件',
  Please_upload_one_of_the_following_proof_of_address_documents: '請上傳下列任一一份地址證明文件：',
  ID_card: '身分證',
  driver_license: '駕照',
  Property_bills_such_as_electricity_bills_water_bills_gas_bills_etc: '物業帳單（如：電費、水費、瓦斯費等）',
  Internet_cable_telephone_bill: '網路/有線電視/電話的帳單',
  Bank_statements: '銀行對帳單',
  credit_card_bill: '信用卡帳單',
  residence_permit: '居住證',
  Affidavit_Certificate_of_Residence: '宣誓書/居住證',
  Household_register: '戶口簿',
  Any_government_issued_documents: '任何政府開立的文件',
  please_enter_user_name: '請輸入用戶名',


  Gender: '姓別',
  Upload_ID_photo: '上傳證件照',
  Make_sure_the_ID_photo_document_shows_your_photo_full_name_date_of_birth_and_document_issue_date: '確保證件照文件顯示您的照片、全名、出生日期和證件開立日期。',
  Demonstrate_correctly: '正確示範',
  Error_demonstration: '錯誤示範',
  ID_photo_reverse_side: '證件照反面',
  Support_jpg_or_png_format: '支持jpg或png格式',
  Photos_are_clear: '照片清晰',
  Details_clearly_visible: '細節清晰可見',
  Photo_quality: '照片高質',
  All_four_corners_of_the_document_are_visible: '文件的四個角均可視',
  Photo_is_blurry_and_out_of_focus: '照片模糊，未對焦',
  Details_not_shown_clearly: '未清晰顯示細節',
  Photo_quality_is_low_too_dark_or_too_bright: '照片品質低（過暗或過亮）',
  All_four_corners_not_shown: '未顯示所有四個角',
  ID_photo: '證件照',
  ID_photo_front: '證件照正面',
  Start_your_trading_journey: '開始您的交易旅程',
  undone: '未完成',
  Trading_System: '交易系統',
  server: '伺服器',
  Download_trading_software: '下載交易軟體',
  PC_version: 'PC版',
  Android_version: '安卓版',
  MT4_account: 'MT4帳戶',
  Leverage_ratio: '槓桿比例',
  _8_20_characters_including_uppercase_and_lowercase_letters_and_numbers: '8-20字符，包含大小寫字母和數字',
  Please_select_account_type: '請選擇帳戶類型',
  photo: '照片',
  Place_of_residence_region: '居住地 (地區)',
  proof_of_address: '地址證明',
  Local_remittance: '本地匯款',
  Beneficiary_bank_area: '收款銀行地區',
  China: '中國',
  Beneficiary_bank_name: '收款銀行名稱',
  Recipient_bank_account_number: '收款銀行帳號',
  Bank_card_front: '銀行卡正面',
  Bank_card_reverse_side: '银行卡反面',
  new_email: '新郵箱',
  The_current_time_period_is_unavailable: '當前時間段不可用',
  Currency: '幣種',
  The_order_was_submitted_successfully_please_wait_for_system_review: '訂單提交成功，請等候系統審核',
  Continue_to_deposit: '繼續存款',
  check_order: '查看訂單',
  Please_upload_payment_voucher: '請上傳支付憑證',
  Please_enter_the_Hash_address_after_the_transaction: '請輸入交易後的Hash地址',
  Billing_message: '收款資訊',
  Coin_deposit_address: '存幣地址',
  payment_voucher: '支付憑證',
  The_maps_address: '圖片地址',
  Payer_wallet_address: '付款人錢包地址',
  wallet_address: '錢包地址',
  Blockchain_transaction_ID: '區塊鏈交易ID',
  Hash_address_after_deposit_is_completed: '存款完成後的Hash地址',
  International_wire_transfer: '國際電匯',
  Bank_name: '銀行名稱',
  Bank_address: '銀行地址',
  Payee_account: '收款人帳戶',
  Payee_Address: '收款人地址',
  Continue_to_withdraw_money: '繼續提款',

  Please_review_and_activate_account: '請查看並激活帳戶',
  Activation_email_received: '未收到激活碼',
  Insufficient_balance: '餘額不足',
  Please_select_a_start_and_end_date: '請選擇日期',
  Transfer_out_account: '轉出帳戶',
  Withdrawal_account: '提款帳戶',
  depositUsdtTips: [
    '1.匯款完成後，請在數位貨幣錢包的提現記錄裡，將附帶完整哈希地址的匯款憑證的截圖，上傳到匯款憑證處。'
  ],
  depositBankTips: [
    '1.請用與實際付款人姓名相同的銀行卡進行轉賬。',
    '2.請不要習慣性轉賬，否則錢款可能無法追回。',
    '3.客戶轉帳金額多於轉帳限額，款項打入了服務提供商的銀行卡且難以追回，一切損失客戶需要自行承擔損失，公司不會提供任何補償。',
    '4.進行銀行轉帳時禁止提供任何備註，如果發現有任何備註，此金額將會退回，而且也會被收取金額的1-2%作為手續費。首次的錯誤操作將會郵件提醒，不會徵收手續費。 第二次將由客戶承擔，一旦出現第三次的錯誤操作將會以惡意客戶嫌疑封禁帳號。',
    '5.若客戶使用異名入金轉賬，將會被收取金額的1-2%作為退款手續費後原路退款。公司政策是不允許異名入金，客戶必須使用本人名義的銀行卡進行入金，避免日後不必要的資金流失。',
  ],
  Please_upload_a_photo_of_holding_your_ID_card: '請上傳手持身分證照片',

  digital_currency: '數位貨幣',
  Confirm_payment_information: '確認支付信息',
  confirm_payment: '確認支付',
  upload_image: '上傳圖片',
  picture_address: '圖片地址',
  main_wallet: '主錢包',
  deposit_account: '存款帳戶',
  Your_new_password_must_be_different_from_your_old_password: '您的新密碼必須與舊的密碼不同',
  Please_enter_the_phone_number: '請輸入手機號碼',
  Please_enter_the_email_address_in_the_correct_format: '請輸入正確格式的郵箱',
  Already_have_an_account: '已有帳戶',
  live: '實盤',

  add_account: '添加帳戶',
  transaction_account: '交易帳戶',
  trade: '交易',
  reactivate: '重新激活',
  I_have_read_understood_and_agreed: '我已閱讀、理解並同意',
  No_account_yet: '還沒有帳戶',
  Account_details: '帳戶詳情',
  pending_order: '掛單',

  // 新加的
  The_activation_email_has_been_sent_successfully_Please_go_to_the_email_to_confirm_the_activation_as_soon_as_possible_Thank_you: '激活郵件發送成功，請盡快前往郵箱確認激活，謝謝！',

  Good_evening: '晚上好',
  Good_afternoon: '下午好',
  good_morning: '上午好',
  family_name: '姓氏',
  Please_fill_in_the_true_and_valid_information: '請填寫真實有效的資訊',
  register: '注冊',
  Return_to_login: '返回登入',
  Verification_Code: '驗證碼',
  Send_verification_code: '發送驗證碼',
  Verification_mode: '驗證方式',
  safety_verification: '安全驗證',
  Mobile: '手机号',
  Account: '帳號',
  WelcomeToMaxain: '歡迎來到Maxain',
  // new
  dashboard: '儀表板',

  // new
  limitRegistPassOneStep: '限制8-20個字符',

  transaction_status: '交易狀態',
  home_agent: '歸屬代理',
  account_information: '账户信息',
  account_type: '帳戶類型',


  // 过渡版本加的
  total: '合計',
  item: '條',
  Whether_the_public: '是否公開',
  remark: '備註',
  field_name: '欄位名',
  table_name: '表名',
  Input_search: '輸入尋找',
  userErrorTips: '請輸入字母、數字和底線的組合，長度在3到20個字符',
  optional: '選填',
  menuName: '名稱',
  loginTimeoutTip: '登入過期，請重新登入',
  Yes: '是',
  no: '否',
  please_sign_in: '請登入',
  username: '用戶名',
  password: '密碼',
  Log_in: '登入',
  Role: '角色',
  please_choose: '請選擇',
  please_input: '請輸入',
  Resign: '離職',
  on_job: '在職',
  show: '展示',
  search: '搜索',
  add: '添加',
  name: '姓名',
  operate: '操作',
  Check: '查看',
  Edit: '編輯',
  delete: '刪除',
  principal: '負責人',
  Confirm: '確認',
  cancel: '取消',
  select_operation: '選擇操作',
  photo_album: '相簿',
  camera: '相機',
  email: '郵箱',
  Superior: '上級',
  phone: '電話',
  save: '保存',
  personal_information: '個人資料',
  Menu_name: '菜單名稱',
  description: '描述',
  state: '狀態',
  Merchant: '商戶',
  Enable: '啓用',
  disabled: '禁用',
  Closure: '關閉',
  confirm_delete: '確定刪除',
  confirm: '確定',
  Please_upload: '請上傳',
  open: '開啓',
  closed: '關閉',
  Component_name: '元件名稱',
  Notice: '注意',
  Description_optional: '描述(選填)',
  // 旧个人中心start
  il8n: {
    change: '切換語言成功',
  },

  Please_select_a_time_range: '請選擇查詢時間範圍',
  A_maximum_of_three_months_can_be_queried: '單次查詢不能超過3個月',

  Web_trader: '網頁交易端',
  balance: '餘額',
  equity: '净值',
  Group: '分組',

  Redemption_expired: '兌換失效',
  Exchange_successfully: '兌換成功',
  Exchange_time: '兌換時間',
  Redeem_products: '兌換產品',
  quantity: '數量',
  Deduct_points: '抵扣積分',

  bonus_time: '獎勵時間',
  Number_of_points: '積分數量',
  Transaction_deposit_amount: '交易/入金數量',
  behavior_type: '行為類型',
  single_deposit: '單次入金',
  first_deposit: '首次入金',
  behavioral_points: '行為積分',
  Trading_Points: '交易積分',
  Points_Available: '可用積分',
  redeemed: '已兌換',
  Points_record: '兌換記錄',
  Summary_points: '總積分',
  Points_type: '積分類型',
  Points_Details: '積分明細',

  MAM_Account_Details: 'MAM帳戶詳情',



  Commission_rebate_rules: '返傭規則',
  Add_a_link: '添加鏈接',
  Direct_customer_class_name: '直客級別名稱',

  Modify_the_rebate_rules: '修改返傭規則',

  log_in_automatically_after: '後自動登入',

  important_Notice: '重要通知',
  do_not_show_again: '不再顯示',
  Got_it: '知道了',


  mobile_phone: '手機',


  Please_upload_the_QR_code: '請上傳二維碼',
  Please_fill_in_the_address: '請填寫地址',
  Please_enter_valid_usdt_address: '請輸入正確的TRC20或BEP20錢包地址',

  bind365_tips: '請注意，務必填寫TRC20或BEP20類型的地址，否則可能無法出金成功。',
  Please_activate_the_binding: '請激活在綁定',
  The_size_of_the_uploaded_avatar_image_cannot_exceed_10MB: '上傳頭像圖片大小不能超過10MB!',

  Holding_ID_photo: '手持證件照',
  Precautions: '注意事項',
  Handheld_ID_photo_verification_failed: '手持證件照審核失敗',

  idRejectLabel: '個人資訊審核失敗',
  addressRejectLabel: '地址證明審核失敗',
  bankRejectLabel: '銀行卡資訊審核失敗',
  QR_code: '二維碼',
  address: '地址',
  The_bank_card_information_has_been_submitted_successfully: '銀行卡資訊提交成功',
  Is_binding: '已綁定',
  The_commission_to_USDT: '出佣到USDT',
  The_commission_to_OTC365: '出佣到ChipPay',
  Bank_card_payment: '银行卡出金',
  withdrawOtcTipThirdlyLine: '系統將支付數位貨幣到第三方數位貨幣交易平台，由第三方平台自動配對交易員，並完成數位貨幣的賣出，請確保交易前您已悉知交易風險。',
  withdrawOtcTipsSecondLine: '到帳金額扣除1USDT，用於支付公鏈產生的礦工費。即時轉帳USDT至OTC365錢包，內建承兌，便捷出入金。',
  withdrawBankCardTipsThirdlyLine: '因配合監管機構反洗錢要求，Maxain將以客戶入金方式相同幣種支付。',
  withdrawBankCardTipsSecondLine: '2.不收取手續費，資金提取到本人銀行卡。',
  withdrawUsdtTipsSecondLine: '2.手續費1USDT，用於支付公鏈產生的礦工費。',
  mamMasterOpenLimitTips: '上榜條件: 收益率大於0，淨值大於$1000，指標每天更新一次',

  MAM_Investor: 'MAM投資帳戶',

  Payment_currency: '支付幣種',
  Amount_deposited: '存款金額',
  share_threeMonthsReturn: '近三月最大回撤',
  share_rate_of_return: '收益率',
  The_poster_has_been_generated_please_share_it: '已生成海報，快去分享吧',
  Duplicated_link_go_share_it: '已複製鏈接，快去分享吧',
  Settlement_not_supported: '不支持結算',
  recommend: '推薦',
  Develop_your_customers_through_poster_links: '透過海報鏈接發展您的客戶',
  Share_Master_Account: '分享主帳戶',
  Save_as_a_poster: '保存為海報',
  copylink: '複製鏈接',
  Sweep_code_to_follow_the_master_profit_together: '掃碼跟著高手一起獲利',
  Close_to_5_liquidations: '近5筆平倉',
  Please_select_the_share_proportion: '請選擇分成比例',
  Please_enter_an_integer_less_than_100: '請輸入小於100的整數',
  Follow_Settings_Successfully: '跟隨設定成功',
  Master_account_special: '主帳戶',
  Follow_the_set: '跟隨設定',
  selected: '已選',
  noOpenTips: '該帳戶已設定為不公開，暫不支持訂閱',
  management_rate_of_return: '管理收益率',
  clientBanlance: '客戶餘額',
  mamSettingChargeNewTips: ['1.開啟收費後，如有免費訂閱者，未開啟交易週期的訂閱者將取消訂閱，已開啟交易週期的將取消自動續費；',
    '2.管理天數滿15天且跟隨帳戶空倉才能結算；',
    '3.可結算整個週期，也可結算單個跟隨帳戶；',
    '4.管理費（管理資金*管理費比例）在加入交易週期時收取；',
    '5.表現費（利潤*分成比例）結算時收取；',
    '6.未結算成功的帳戶進入下一個週期不收取管理費。'],
  ecnReadyOnlyTips: 'ECN帳戶最低入金要求是${money}，未滿足要求暫時無法交易',
  mamSubReadyOnlyTips: 'MAM投資帳戶無法自主交易，僅能用於複製跟單',
  proReadyOnlyTips: 'PRO帳戶最低入金要求是${money}，未滿足要求暫時無法交易',

  yesterday: '昨日',
  Nicknames_cannot_be_changed_after_they_are_set: '暱稱設定後將無法修改',
  autonomous_transaction: '自主交易',
  Documentary_transactions: '跟單交易',
  integerTips: '請輸入正整數',
  StopRatioValiteTips: '請輸入0.01的倍數，不得超過100，最多兩位小數',

  mamMasterSettingSaveTips: '1.如修改公開狀態或訂閱費，則所有跟隨者將取消自動續費；<br/>2.如修改免費為收費，未開啟交易週期的跟隨者將取消訂閱，已開啟交易週期的將取消自動續費。',

  attention_please: '請注意',

  Charge_information_confirmation: '收費資訊確認',
  You_have_read_and_agree: '您已閱讀並同意',
  Documentary_agreement: '跟單協議',
  Please_enter_your_subscription_password: '請輸入訂閱密碼',
  Not_less_than_the_minimum_funds_under_management: '不能少於最低管理資金',
  Please_select_a_MAM_account: '請選擇mam帳戶',
  wrong_password: '密碼錯誤',
  Subscribe_to_the_success: '訂閱成功',
  Unavailable_account: '無可用帳戶',
  Now_open_an_account: '現在開戶',


  Investment_account: '投資帳戶',
  copyValidateTips: '只能是0.01的倍數，並且最多兩位小數',
  copyValueNullValidateTips: '請輸入固定手數或固定比例',
  maximum_ratio: '最大比例',
  Now_deposit: '現在入金',
  available_balance: '可用餘額',
  Please_enter_a_multiple_of_10: '請輸入10的倍數',
  mamSubCopyMoneyTips: '啟用時收取。 表現費如下表，結算時收取。',
  The_account_to_pay_the_management_fee: '支付管理費的帳號',
  Insufficient_available_balance: '可用餘額不足，',
  Edit_success: '編輯成功',
  Account_number_has_reached_maximum_limit: '帳戶數已達到最大限制，',
  The_funds_under_management_must_not_exceed_the_account_balance: '管理資金不能大於帳戶餘額',
  Please_enter_managed_funds: '請輸入管理資金',

  Support_for_autonomous_trading: '支持自主交易',
  SocialMasterRoleTips: 'Social跟單信號源帳戶，支援自主交易',
  SocialSubRoleTips: '用于訂閱跟單Social信號源賬戶，支持自主交易',
  mamMasterSubRoleTips: 'MAM資管交易主賬戶，設置費率並開啓交易',
  mamSubSubRoleTips: 'MAM投資賬戶，委托主賬戶管理賬戶資金,不支持自主交易',
  moneyRoleTips: '用於訂閱收入和管理費支出，支援自主交易',

  no_limit: '不限制',
  fixed_lots: '固定手數',
  fixed_proportion: '固定比例',
  Smart_proportion: '智能比例',
  multiple: '倍',
  Experience_account: '體驗',

  All_have_been_read: '全部已讀',
  order: '訂單',


  Subscribe_to_the_number_of: '訂閱人數',
  filtrate: '篩選',
  maximum_drawdown: '最大回撤',
  week: '周',
  reset: '重置',

  stop: '停止',

  Renew: '續訂',
  cost: '費用',

  invalid: '無效',
  valid: '有效',
  finished: '已結束',
  my_subscriptions: '我訂閱的',
  Subscribe_to_my: '訂閱我的',

  Investment_community: '投資社區',
  After_the_nickname_is_set_no_modification_is_allowed: '暱稱設定後不允許修改',
  Wallet_account_edit_tips: '修改後，原始錢包帳戶將變為普通帳戶',
  Confirm_save: '確認保存',
  idChangeTips: '帳戶身分設定後無法變更，確認保存？ ',

  please_enter: '請輸入',
  Account_identity: '帳戶身份',
  Account_identity_tips1: '普通賬戶：用于自主交易；',
  Account_identity_tips2: '錢包賬戶：用于收支訂閱費用，也支持自主交易；',
  Account_identity_tips3: 'Social主賬戶：Social跟單信號源賬戶；',
  Account_identity_tips4: 'Social投資帳戶：用於複製Social信號源帳戶進行投資，支持自主交易；',
  Account_identity_tips5: 'MAM主帳戶：可接受MAM投資帳戶委託管理其帳戶資金並收取相應費用，支持自主交易；',
  Account_identity_tips6: 'MAM投資帳戶：可委託MAM主帳戶管理帳戶資金，不支持自主交易。',

  My_balance: '我的餘額',
  mamCancleTips: '取消訂閱後，持倉訂單將全部平倉且無法享有未到期的服務。 管理費不退款，表現費請等待系統結算。 確認取消？',
  Time_spent: '支出時間',
  Saved_successfully: '保存成功',
  Not_set: '未設定',

  Total_subscription_revenue: '訂閱總收益',
  To_open_the_next_issue: '待開啓下一期',
  Subscription_yield: '訂閲收益率',

  Total_revenue: '總收入',
  Management_fee_ratio: '管理費比例',
  Performance_fee_ratio: '表現費比例',
  Follow_income: '跟隨收益',
  Please_enter_the_management_fee_ratio: '請輸入管理費比例',
  Please_enter_the_share_ratio: '請輸入分成比例',
  Fill_in_at_least_one_charging_rule: '至少填寫一項收費規則，管理費和表現費分成不能都為0',

  Settled_successfully: '結算成功',
  To_enable_the: '啟用中',
  noEnableTheTips: '交易週期少於15天，不符合結算條件',
  Pending_settlement: '待結算',
  settled: '已結算',
  Customer_nickname: '客戶暱稱',

  Trading_cycle: '交易周期',
  Settlement_conditions: '結算條件',
  cycleTips1: '交易週期少於15天',
  cycleTips2: '跟隨帳戶空倉',
  settle: '結算',
  Settlement: '結算中',
  Issue: '期號',
  Management_days: '管理天數',
  Personal_funds: '個人資金',
  Personal_gain: '個人收益',
  Manage_funds: '管理資金',
  Management_income: '管理收益',
  Estimate: '估算',

  startBeforeTipsTitle: '確認啟用',
  startBeforeTips: '啟用後開始新一輪交易週期，跟單設定將生效並扣除管理費，確認啟用',
  Successfully_activated: '啟用成功',
  settleBeforeTips: '結算期間將關閉跟單功能，啟用後重新開啟跟單，確認結算？',
  Confirm_settlement: '確認結算',

  Cumulative_number_of_managed_accounts: '累計管理帳戶數',
  Number_of_trading_periods: '管理期數',
  Accumulated_funds_under_management: '累計管理資金',
  Average_management_rate_of_return: '平均管理收益率',
  Total_Management_Revenue: '管理總收益',
  Average_billing_cycle: '平均結算週期',
  Total_personal_income: '個人總收益',
  Transaction_order: '交易訂單',

  Stop_loss_ratio: '止損比例',
  Charging_cycle: '收費週期',
  Resubscribe: '重新訂閱',

  signal_source: '信號源',
  Allocation: '分配方式',
  transactions: '筆',
  Maximum_follow_number: '最大跟隨持倉筆數',
  Maximum_follow_lot: '最大跟隨持倉手數',
  Follow_the_order: '跟隨下單',
  Edit_subscription: '編輯訂閱',
  unsubscribe: '取消訂閱',
  socialSubCancelCopyButtonText: '確認取消',
  cancleSuccess: '取消成功',


  expenses: '支出',

  Autonomous_transaction: '自主交易',
  Copy_transaction: '複製交易',
  Autonomous: '自主',


  Is_it_public: '是否公開',
  Follower_funding_limit: '跟隨者資金限制',
  Unlimited: '不限',
  Subscription_password: '訂閱密碼',
  digit6_combination_of_numbers_and_letters: '數字和字母組合的6-20位數',
  charge: '收費',

  nickname: '暱稱',

  Copy_settings: '跟單設定',

  Payment_time: '支付時間',
  month: '月份',
  types_of_fee: '費用類型',
  payment_account: '付款帳戶',
  Pay_on_behalf_of: '代付',
  Collection: '代收',
  Accounts_receivable: '收款帳戶',

  Cumulative_number_of_follow: '累計跟隨筆數',
  Cumulative_follow_lot: '累計跟隨手數',


  Turned_on: '已開啓',
  Not: '否',
  Automatic_renewal: '自動續費',
  Current_follow: '當前跟隨筆數',
  Current_follow_lot: '當前跟隨手數',
  Subscription_revenue: '訂閲收益',
  Subscription_days: '訂閲天數',

  Subscribing: '訂閲中',
  expired: '已過期',

  Cumulative_subscription: '累計訂閲',
  Cumulative_subscription_revenue: '累計訂閲收益',
  Cumulative_subscription_lot: '累計訂閲手數',
  income: '收入',


  Profitability: '盈利能力',
  Robustness: '穩健能力',
  Risk_control_ability: '風控能力',
  Fund_size: '資金規模',
  Trading_activity: '交易活躍度',

  Grand_total: '累計',
  Today: '當日',
  Nearly_three_months: '近三個月',
  Short: '做空',
  Do_more: '做多',
  Variety_ranking: '品種排行',
  Yield_curve: '收益曲綫',

  Basic_Information: '基本信息',
  Subscription_fee: '訂閲費',
  free: '免費',
  Experience: '體驗',
  Share_ratio: '分成比例',
  Performance_fee: '表現費',

  management_fee: '管理費',
  No: '暫無',
  Strategy_description: '策略説明',
  Minimum_funding_limit: '最低資金限制',
  Master_account: '主',
  rate_of_return: '收益率',
  threeMonthsReturn: '近三月最大回撤',
  Overview: '概覽',
  Setting: '設定',
  subscription: '訂閲',
  Please_enter_a_nickname: '請輸入昵稱',
  Wallet_account: '錢包',
  Social_account: 'Social賬戶',
  MAM_account: 'MAM賬戶',
  MAM_master_account: '主賬戶',
  MAM_Investment_Account: '投資賬戶',
  Social_master_account: 'Social主',
  Social_Investment_Account: 'Social投資',
  You_can_also_add: '還可以新增',
  Trading_accounts: '個交易賬戶',
  More: '更多',
  Read_only: '只讀',
  Identity: '身份',

  readOnlyTips: '由於净值低於信用額導致信用額凍結，可再次入金並聯絡客服申請解凍並繼續完成任務，也可取消信用額直接解凍',
  stopRatioExplain: '當前净值/初始净值≤設定比例時，將暫停跟單，所有持倉訂單强制平倉，止損比例重置。出入金或轉賬后該值也會被重置。',
  mtAccount: 'mt4賬戶',
  bind: '綁定',
  riskFileName: '風險披露',
  saveFileName: '安全説明',
  and: '和',
  limitRegistPassTwoStep: '包含大小寫字母和數字',

  welcome: '歡迎來到',
  GoToRegister: '去注冊',

  resetPass: '重置密碼',
  To_log_in: '去登入',

  personal: '個人',
  partner: '合夥人',
  phoneEmtpyTips: '手機號不能為空',
  select_rebate_level: '請選擇返佣級別',
  editSuceess: '修改成功',
  Modify_agent_level: '修改代理級別',
  Please_enter_password: '請輸入密碼',
  please_input_your_email: '請輸入郵箱',
  registration_success: '註冊完成待激活',
  activateImmediately:'立即激活',
  Please_keep_your_password_properly: '請妥善保存您的密碼',
  pleaseEnterTheCompleteActivationCode:'请输入完整的激活码！',
  log_in_immediately: '立即登入',
  Upload_positive: '上傳正面',
  Upload_negative: '上傳反面',
  Privacy_agreement: '隱私協議',
  Prevent_money_laundering: '防止洗錢',
  safety_instructions: '安全説明',
  infoRejectTips: '請根據郵件提示，進行資料修改並重新提交',
  Authenticate_now: '立刻認證',
  My_rebate_rules: '我的返佣規則',
  The_highest_can_be_set: '最高可設',
  Please_fill_out: '請填寫',
  Fill_in_at_most_one_decimal: '最多填寫一位小數',
  Commission_statistics: '佣金統計',
  today: '今日',
  All: '全部',
  Nearly_a_month: '近一個月',
  Nearly_a_year: '近一年',
  Unbound: '未綁定',
  Home_agent: '歸屬代理',
  client: '客戶',
  Myself: '本人',
  All_subordinates: '所有下級',
  Self_held_account_transfer_and_withdrawal: '自持賬戶轉賬出金',
  Transfer_and_withdraw_funds_from_other_accounts: '他人賬戶轉賬出金',
  Bank_card: '銀行卡',
  Alipay: '支付寶',
  other: '其它',
  credit_amount: '信用額',
  Open_a_position: '開倉',
  Account_type: '賬戶種類',
  normal: '正常',
  Agent_ID: '代理ID',
  direct: '直接',
  indirect: '間接',
  Authentication_failed: '認證失敗',
  Account_under_name: '名下賬戶',
  Registration_time: '注冊時間',
  modify: '修改',
  Commission: '出佣',
  Choose_verification_method: '選擇驗證方式',
  correct: '正確',
  Investment_objective: '投資目標',
  of: '的',
  Transaction_history: '交易歷史',
  Limit_more_than_6_characters: '限制大於6個字符',
  Contains_letters_and_numbers: '包含字母和數字',
  Direct_link: '直客鏈接',
  mine: '我的',
  Re: '重新',
  uploadAddressFileSuccessTips: '地址文件上傳成功',
  Need_to_log_in_again: '需要重新登錄',
  Ordinary_account: '普通',
  Demo_account: '模擬',
  openAccPageTips: '部分金融品種可能會受固定保證金要求影響，因此導致您的實際槓桿低於帳戶設定中選定的槓桿。具體資訊請參考"合約細則"或造訪我們的網站。',
  mockOpenSuccessTip: '模擬帳戶開立成功',
  Total_deposit: '總入金',
  Total_withdrawal: '總出金',
  Apply_to_transfer_out: '申請轉出',
  profit: '盈利',
  Bank_card_number: '銀行卡號',
  Transfer_out_to_bank_card: '轉出到銀行卡',
  Transfer_to_MT4: '轉出到MT4',
  experienceNoCardTips: '請綁定銀行卡再轉出',
  experienceNoMt4Tips: '請先建立mt4帳戶',
  Account_has_expired: '帳戶已過期',
  personInfoAuthFail: '審核不通過',
  day: '天',
  mobileAreaTips: '請選擇地區',
  details: '詳情',
  accountDetails: '帳號詳情',
  orderSource: '訂單來源',
  root: {
    selectPls: '請選擇',
    enterPls: '請輸入內容',
    confirm: '確定',
    cancle: '取消',
    noData: '暫無數據',
    dateTo: '至',
    startDate: '開始日期',
    endDate: '結束日期',
    search: '搜索',
    export: '導出',
    time: '時間',
    upper: '上一步',
    next: '下一步',
    yes: '有',
    no: '沒有',
    selectAccount: '選擇帳戶',
  },
  HeaderCom: {
    login: '登入',
    register: '註冊',
    userCenter: '個人中心',
    invite: '邀請',
    exit: '退出',
  },
  Login: {
    login: '登入',
    passwordTip: '密碼',
    forgetPwd: '忘記密碼',
    register: '註冊',
    phoneVer: '手機驗證',
    emailVer: '郵箱驗證',
    successSetPwd: '密碼重置成功',
    loginTimeoutTip: '您的帳號登入已失效，請重新登入。',
  },
  Register: {
    title: '註冊',
    perInfo: '個人資料',
    declare: '聲明',
    firstName: '姓氏',
    lastName: '名字',
    rePswText: '確認密碼',
    againVer: '後再次獲取',
    errorPhon: '請填寫正確的手機號',
    errorMail: '請填寫正確的郵箱號碼',
    errorFirstName: '請輸入姓氏',
    notpassword: '密碼輸入錯誤',
    notrepassword: '輸入的兩次密碼不一致，請重新輸入',

    passwordDes: "必須包含大小寫字母和數字的組合，不能使用特殊字符，長度在8-20之間",
    verText: "驗證碼",
    submitText: '提交',
    successTips1: '激活碼已發至您的注冊郵箱：',
    successTips2: ',請查收並激活帳號',
    successTips4: '重新發送',
    successTips5: '激活郵件發送成功，請盡快前往郵箱確認激活，謝謝！',
    sendEmail: '發送激活郵件',
    unCheck: '未激活',
    userName: '用戶名稱',
    idNo: '證件號碼',
    openAcc: '確認開戶',
  },
  About: {
    branch: '辦事處',
    phone: '電話',
    language: '語言',
    sendEmail: '發送電子郵件',
    name: '姓名',
    email: '郵箱',
    submitText: '提交申請',
    notice: '公告',
  },
  Home: {
    least: '最低入金',
    lever: '槓桿',
    accountType: '帳戶類型',
    forexVolume: '交易量',
    forexLot: '手',
  },
  Partner: {
    name: '名字',
    email: '郵箱',
    region: '請指明您計劃開展經營的地區',
    experience: '您有沒有與其他金融公司合作過？ 如有，請說明是哪些公司，於何時合作？',
    upload: '上傳',
    inputVer: '請輸入驗證碼',
    commitSuccess: '提交成功',
    delete: '確定移除',
  },
  Tools: {
    exchange: '貨幣轉換',
    year: '年',
    month: '月',
    day: '日',
    USD: '美元',

  },
  Trade: {
    equity: '淨值（USD)',
    payType: '支付系統',
    deposit: '存入資金',
    withdraw: '提取資金',
    oper: '操作',
    mix: '最低',
    max: '最高',
    poundage: '手續費',
    depo: '入金',

    /*新的银联支付方式*/
    title: '支付金額並確認',
    subtitle: '完成充值後您購買的數位貨幣將全額充值到該商戶',
    orderNo: '訂單號',
    payMoney: '支付金額',
    copy: '複製',

    bankInfo: '銀行資訊：',
    remark: '付款備註：',
    countDown: '支付倒計時：',
    warning: '警告：如未成功轉賬，請勿點擊“確認已支付”，否則將會限制當日買入及到賬！',
  },
  Train: {
    all: '全部',
    class: '分類',
    sort: '排序',
    lecturesAddr: '詳細地址',
    viewMore: '查看更多',
    apply: '立即報名',
    firstName: '姓',
    lastName: '名',
    experience: '經驗',
    phone: '手機號碼',
    email: '郵箱',
    yes: '有',
    no: '没有',
    back: '返回',
  },
  Market: {
    calendar: '經濟日曆',
    time: '時間',
    event: '事件',
    important: '重要性',
    now: '今值',
    pre: '前值',
  },
  User: {
    home: '首頁',
    myAcc: '我的帳戶',
    monChan: '入金',
    partner: '合作夥伴',
    perInfo: '個人資料',
    goldManage: '贈金記錄',
    setup: '帳戶設定',
    leastDeposit: '最低入金',
    leverage: '槓桿',
    forexLeverage:'外匯槓桿',
    preciousMetalLeverage:"貴金屬槓桿",
    liquidationRatio:"強平比例",
    collateralMarginRatio:"鎖倉保證金",
    accountCardTips1:"外匯貨幣對的槓桿",
    accountCardTips2:"黃金和白銀的槓桿",
    accountCardTips3:"保證金水平降至或低於此閾值時，系統將自動平倉。",
    accountCardTips4:"訂單對鎖時每個訂單的保證金佔用的百分比",
    withdrawtipsName:"賬戶持倉情況下可提取金額為可用保证金*",
    withdrawtipsAction:"，如需特殊提取請聯繫在線客服協助。",
    leverageBest: '槓桿最高',
    unit: '最小合約單位（合約量）',
    miniSpreads: '最低點差',
    selectLev: '請選擇槓桿',
    currency: '帳戶貨幣',
    openAcc: '開立帳戶',
    accountList: '帳戶列表',
    totalBalance: '總餘額',
    applyCommi: '申請出佣',
    status: '狀態',
    remainAmount: '可出佣金額',
    transactionStatus: '交易狀態',
    startUsing: '啓用',
    forbidden: '禁用',
    login: '賬號',
    accType: '類型',
    balance: '當前餘額',
    equity: '當前資產淨值',
    credit: '信用額',
    marginFree: '可用保證金',
    profitRate: '帳戶總利潤率（%）',
    openOrder: '未結訂單數',
    closeOrder: '已結訂單數',
    createTime: '註冊日期',
    checking: '資料審核中',
    userInfo: '個人資訊',
    name: '姓名',
    surnameNullMessage: '請輸入姓',
    nameNullMessage: '請輸入名字',
    regionNullMessage: '請選擇地區',
    gender: '性别',
    man: '先生',
    women: '女士',
    nationality: '國籍',
    homeCountryCode: '居住國',
    phone: '手機號碼',
    certId: '證件號碼',
    birthday: '出生日期',
    authentication: '身份驗證',
    authPass: '審核通過',
    authing: '審核中',
    addressVerifi: '地址驗證',
    sumit: '提交審核',
    authSubmitSuccess: '身份證明提交成功',
    add: '添加',
    email: '郵箱',
    newPhone: '新手機號',
    sendVeri: '發送驗證碼',
    sendDesc: '後來再獲取',
    phoneVerCode: '手機驗證碼',
    emailVerCode: '郵箱驗證碼',
    save: '保存',
    verCodeSendSuccess: '驗證碼發送成功',
    plsInputNewPhone: '請輸入您的新手機號',
    plsInputPhoVer: '請輸入驗證碼',
    addPhoneSuccess: '添加成功',
    worlSta: '就業狀況',
    industry: '產業',
    income: '年收入',
    netAsset: '淨資產',
    curAsset: '流動資產',
    fundsSource: '投資資金來源',
    bankCardInfo: '銀行卡信息',
    bankAccount: '銀行帳號',
    bankName: '開戶銀行',
    receivingCurrency: "收款幣種",
    account_currency: "賬戶幣種",
    bankOutlet: '開戶支行',
    reBind: '重新綁定',

    worlStaNullMessage: '請選擇就業狀況',
    industryNullMessage: '請選擇行業',
    incomeNullMessage: '請選擇年收入',
    AssetsNullMessage: '請選擇淨資產',
    runAssetsNullMessage: '請選擇你的流動資產',
    fundsSourceNullMessage: '請勾選你的投資資金來源',

    plsInputBankFront: '請上傳銀行卡照片（正面）',
    plsInputBankBack: '請上傳銀行卡照片（反面）',
    plsInputBankAccount: '請輸入銀行帳號',
    plsInputBankName: '請輸入開戶銀行',
    plsInputBankOutlet: '請輸入開戶支行',
    CNYNAME: "人民幣",
    VNDNAME: "越南盾",
    Rpcurrency:"印尼盾",
    OTHER_BANKS: "其他銀行",
    plsInputSwiftCode: '請輸入SwiftCode',
    investExp: '投資經驗',
    invTarget: '投资目标是',
    levHis: '请告诉我们您是否有其它杠杆式产品（如窝轮、期货、期权）交易历史',
    howTrade: '您是如何交易以上产品的？',
    invTargetIs: '您的投資目標是？（可多選）',
    plsInputInvTarget: '您的投資目標是？',
    firstName: '姓',
    cardType: '證件類型',
    plsInputAddress: '請選擇地區',
    plsInputName: '請輸入姓名',
    openAccTips3: '我認為貴公司提供的產品適合我',
    openAccTips4: '我理解此投資產品為投機性，並且我可以根據個人財務狀況承擔所有投資金額風險',
    openAccTips5: '我理解在交易槓桿產品時，我冒著失去所有投資資金的風險；我有責任透過風險管理工具(例如止損單)來監控我的倉位並管理交易風險。',
    openAccTips6: '本人同意客戶協議書及所有條款以電子形式而非紙本形式收集和發送，包括文件電子簽名和帳戶資訊的發送。',
    openAccTips7: '此外，本人聲明，本人提供的所有開戶資訊均真實準確並保證在內容有任何變化的情況下以書面形式通知經紀商公司，必要時，本人授權經紀商公司對資料的準確性進行校驗確認。',

    //转账
    transferAccounts: '轉帳',
    from: '從',
    to: '到',
    amount: '金額',
    onlyInputTwoBitNumber: '只能輸入兩位小數金額',
    transDesc: '如果您知道收款人的電子郵件地址（收款人個人專區的主要電子郵件或任何替代電子郵件地址），請輸入。系統將驗證您輸入的收款人帳號和電子郵件地址是否正確。如果它們不匹配，則內部轉帳不會執行。',
    transAmount: '轉帳金額',
    fee: '手續費',
    //tradeHistory
    payType: '支付方式',
    num: '編號',
    searchType1: '銀聯入金1',
    searchType2: '自持帳戶轉入',
    searchType3: '他人帳戶轉入',
    searchType4: '銀聯入金2',
    searchStatus2: '入金成功',
    searchStatus3: '入金失敗',
    outAmount: '出金金額',
    searchOutType1: '出金到銀行卡',
    searchOutType2: '出金到自有帳戶',
    searchOutType3: '出金到他人帳戶',
    searchOutType4: '其他',
    searchOutStatus1: '審核中',
    searchOutStatus2: '出金成功',
    searchOutStatus3: '出金失敗',
    depositTimeTips: '該頻道不在可用時間內，請選在其他管道，謝謝！',
    //moneyChange
    in: '入金',
    out: '出金',
    limit: '限額',
    timeLimit: '限時',
    moneyConfirm: '確認',
    moneyBanlanceNotEnough: '可用餘額不足，請選擇其他帳號提款',
    moneyAmountError: '出金金額大於可提款金額',
    moneyAmountErrorCommission: '出佣金額大於可提款金額',
    //setting
    leverSet: '槓桿設定',
    modifyLeverSuccess: '槓桿修改成功',
    saveSetting: '儲存設定',
    passSet: '密碼設定',
    newPass: '新密碼',
    confirmPass: '再次輸入密碼',
    plsInputPass: '請輸入新密碼',
    plsInputConfirmPass: '請輸入確認密碼',
    modifyPass: '更改密碼',
    passType2: '交易密碼',
    passType3: '投資密碼',
    passSetSuccess: '修改密碼成功',
    //partner
    commissionBanlance: '餘額',
    totalProfit: '總收益',
    copySuccess: '複製成功',
    reportCloseOrder: '平倉單',
    reportSubibList: '子IB列表',
    reportCommiRecord: '出佣記錄',
    reportOrderId: '訂單號',
    reportCusId: '客戶ID',
    reportSymbol: '品種',
    reportCmd: '交易類型',
    reportVolume: '交易量',
    reportCurrentPrice: '目前價格',
    reportCloseTime: '平倉時間',
    reportClosePrice: '平倉價格',
    reportSl: '止損',
    reportTp: '止盈',
    reportStorage: '利息',
    reportProfit: '盈虧',
    total: '合計',
    buy: '買入',
    sell: '賣出',
    reportCusType: '客戶類型',
    reportBanlance: '餘額',
    reportEquity: '淨值',
    reportImgStatus: '資料認證',
    reportCreateTime: '開戶時間',
    reportDir: '直接客戶',
    reportIndir: '間接客戶',
    auth: '認證',
    identifyStatus0: '未認證',
    identifyStatus1: '認證不通過',
    identifyStatus2: '認證中',
    identifyStatus3: '認證通過',
    custStatus2: '開戶成功',
    custStatus3: '審核中',
    custStatus4: '審核失敗',
    reportComiType: '出佣方式',
    reportComiType1: '出佣到銀行卡',
    reportComiType2: '內部轉帳',
    reportCommiAmount: '出佣金額',
    reportCommiStatus1: '出佣成功',
    reportCommiStatus2: '已否絕/取消',
    reportCommiStatus3: '審核中',
    confirmCancelCommission: '確認取消出佣',
    confirmCancelWithdrawal: '確認取消出金',
    applyTime: '申請時間'
  },
  contractDetailed: {
    tradingHour: '交易時間',
  },
  riskExplain: {
    title: '風險與聲明'
  },
  //电汇
  telegraphicTransfer: {
    tips: '安全交易須知',
    tipsTwo: '安全交易須知：',
  },
  // 赠金
  withgold: {
    title: '贈金記錄',
    Numbering: '編號',
    accountNumber: 'MT4帳號',
    BonusType: '贈金類型',
    BonusAmount: '贈金金額',
    DepositAmount: '入金金額',
    EventName: '活動名稱',
    NumberOfLots: '達標手數',
    LotsCompleted: '完成交易手數',
    ExpireDate: '到期時間',
    status: '狀態',
    freeStatusTipsOne: '由於淨值低於信用額導致信用額凍結，',
    freeStatusTipsTwo: '可再次入金並聯絡客戶經理申請解凍並繼續完成任務，',
    freeStatusTipsThree: '也可取消信用額直接解凍',
    operating: '操作',
    RollOut: '轉出',
    statusEnd: '已結束',
    statusDuring: '進行中',
    statusExpired: '已過期',
    statusFree: '已凍結',
    statusComple: '已完成',
    statusCancle: '已取消',
    statusReview: '轉正審核',
    sureTitle1: '目前可轉出',
    sureTitle2: '轉出信用額有觸發平倉風險，建議未持倉時申請',
    sureTitleCenter: '轉到餘額',
    operatingSuccess: '操作成功',
    cancleTitle: '取消信用額有觸發平倉的風險，建議您在未持倉時取消',

    // 转出记录页面
    mt4Account: 'MT4帳號',
    RollOutAmount: '轉出金額($)',
    SubmitTime: '提交時間',
    withgoldOut1: '待審核',
    withgoldOut2: '已通過',
    withgoldOut3: '已拒絕',

    // 头部
    selectAccount: '請選擇帳戶',
    inputEventName: '輸入活動名稱',
    clearEmipt: '清空',

    // tab
    TransferRecord: '轉出記錄',
    // 账号冻结状态的提示
  },
  payChannel: {
    inputMoney: '請輸入入金金額',

  },
  // 积分商城菜单下的,没有英语版本的
  integralShop: {
    sort_by: '排序方式'
  },
  download: {
    subtitle: "下載 MetaTrader 4，體驗終極交易體驗！",
    smallTextwindows: "Windows 桌面版",
    smallTextios: "iOS 移動端",
    windowsdesc: "系統要求：適用於 Windows 2008/7/8/10 作業系統",
    iosdesc: "下載說明：iPhone 和 iPad 用戶可透過 Apple App Store 搜尋 MetaTrader4 進行安裝。",
    androiddesc: "下載說明：下載後可透過手機安裝 APK"
  },
  address_prompt:"您填寫的地址信息必須與您提供的地址證明文件上的信息保持一致，否則可能導致認證失敗。",
  // 佣金規則相關
  'cannot_be_empty': '不能為空',
  'cannot_be_negative': '不能為負數',
  'invite_code': '邀請碼',
  assetsList: {
    level1: '少於$25,000',
    level2: '$25,000 - $49,999',
    level3: '$50,000 - $99,999',
    level4: '$100,000 - $249,999',
    level5: '$250,000 - $1,000,000',
    level6: '多於$1,000,000',
  },
  certTypes: {
    idCard: '身份證',
    passport: '護照',
    driverLicense: '駕照',
    householdBook: '戶口本',
    residencePermit: '居住證',
  },
  countryList: {
    china: '中國',
    taiwan: '中國臺灣',
    hongKong: '中國香港',
    macau: '中國澳門',
    mongolia: '蒙古',
    japan: '日本',
    philippines: '菲律賓',
    vietnam: '越南',
    laos: '老撾',
    cambodia: '柬埔寨',
    burma: '緬甸',
    thailand: '泰國',
    malaysia: '馬來西亞',
    brunei: '文萊',
    singapore: '新加坡',
    indonesia: '印度尼西亞',
    eastTimor: '東帝汶',
    nepal: '尼泊爾',
    bhutan: '不丹',
    bangladesh: '孟加拉國',
    india: '印度',
    pakistan: '巴基斯坦',
    sriLanka: '斯里蘭卡',
    maldives: '馬爾代夫',
    kazakhstan: '哈薩克斯坦',
    kyrgyzstan: '吉爾吉斯斯坦',
    tajikistan: '塔吉克斯坦',
    uzbekistan: '烏茲別克斯坦',
    turkmenistan: '土庫曼斯坦',
    afghanistan: '阿富汗',
    iraq: '伊拉克',
    syria: '敘利亞',
    jordan: '約旦',
    israel: '以色列',
    palestine: '巴勒斯坦',
    saudiArabia: '沙特阿拉伯',
    bahrain: '巴林',
    qatar: '卡塔爾',
    kuwait: '科威特',
    unitedArabEmirates: '阿拉伯聯合酋長國（阿聯酋）',
    oman: '阿曼',
    yemen: '葉門',
    georgia: '格魯吉亞',
    armenia: '亞美尼亞',
    azerbaijan: '阿塞拜疆',
    turkey: '土耳其',
    cyprus: '塞浦路斯',
    finland: '芬蘭',
    sweden: '瑞典',
    norway: '挪威',
    iceland: '冰島',
    denmark: '丹麥',
    faroeIslands: '法羅群島（丹）',
    estonia: '愛沙尼亞',
    latvia: '拉脫維亞',
    lithuania: '立陶宛',
    russia: '俄羅斯',
    moldova: '摩爾多瓦',
    poland: '波蘭',
    czechRepublic: '捷克',
    slovakia: '斯洛伐克',
    hungary: '匈牙利',
    germany: '德國',
    austria: '奧地利',
    switzerland: '瑞士',
    liechtenstein: '列支敦士登',
    unitedKingdom: '英國',
    ireland: '愛爾蘭',
    netherlands: '荷蘭',
    belgium: '比利時',
    luxembourg: '盧森堡',
    france: '法國',
    monaco: '摩納哥',
    romania: '羅馬尼亞',
    bulgaria: '保加利亞',
    serbia: '塞爾維亞',
    macedonia: '馬其頓',
    albania: '阿爾巴尼亞',
    greece: '希臘',
    slovenia: '斯洛文尼亞',
    croatia: '克羅地亞',
    bosnia: '波斯尼亞',
    meskovina: '墨塞哥維那',
    chad: '乍得',
    centralAfrica: '中非',
    cameroon: '喀麥隆',
    equatorialGuinea: '赤道幾內亞',
    gabon: '加蓬',
    saoTome: '聖多美及普林西比',
    mauritania: '毛里塔尼亞',
    westernSahara: '西撒哈拉',
    senegal: '塞內加爾',
    gambia: '岡比亞',
    mali: '馬里',
    burkinaFaso: '布基納法索',
    guinea: '幾內亞',
    guineaBissau: '幾內亞比紹',
    capeVerde: '佛得角',
    sierraLeone: '塞拉利昂',
    ghana: '加納',
    togo: '多哥',
    benin: '貝寧',
    niger: '尼日爾',
    canaryIslands: '加那利群島（西）',
    zambia: '讚比亞',
    angola: '安哥拉',
    zimbabwe: '津巴布韋',
    malawi: '馬拉維',
    mozambique: '莫桑比克',
    botswana: '博茨瓦納',
    namibia: '納米比亞',
    southAfrica: '南非',
    swaziland: '斯威士蘭',
    lesotho: '萊索托',
    madagascar: '馬達加斯加',
    comoros: '科摩羅',
    mauritius: '毛里求斯',
    reunion: '留尼旺（法）',
    stHelena: '聖赫勒拿（英）',
    australia: '澳大利亞',
    newZealand: '新西蘭',
    papuaNewGuinea: '巴布亞新幾內亞',
    solomonIslands: '所羅門群島',
    vanuatu: '瓦努阿圖',
    micronesia: '密克羅尼西亞',
    marshallIslands: '馬紹爾群島',
    palau: '帕勞',
    nauru: '瑙魯',
    kiribati: '基里巴斯',
    tuvalu: '圖瓦盧',
    samoa: '薩摩亞',
    fijiIslands: '斐濟群島',
    tonga: '湯加',
    cookIslands: '庫克群島',
    guam: '關島',
    newCaledonia: '新喀里多尼亞(法)',
    polynesia: '波利尼西亞',
    pitcairnIsland: '皮特凱恩島（英）',
    wallisAndFutuna: '瓦利斯與富圖納（法）',
    niue: '紐埃',
    tokelau: '托克勞',
    mexico: '墨西哥',
    greenland: '格陵蘭（丹）',
    guatemala: '危地馬拉',
    belize: '伯利茲',
    elSalvador: '薩爾瓦多',
    honduras: '洪都拉斯',
    nicarguagua: '尼加拉瓜',
    costaRica: '哥斯達黎加',
    panama: '巴拿馬',
    bahamas: '巴哈馬',
    cuba: '古巴',
    jamaica: '牙買加',
    haiti: '海地',
    dominicanRepublic: '多米尼加共和國',
    antigua: '安提瓜',
    barbuda: '巴布達',
    stKitts: '聖基茨',
    nevis: '尼維斯',
    dominic: '多米尼克',
    saintLucia: '聖盧西亞',
    saintVincent: '聖文森特',
    grenadines: '格林納丁斯',
    grenada: '格林納達',
    barbados: '巴巴多斯',
    trinidad: '特立尼達',
    tobago: '多巴哥',
    puertoRico: '波多黎各',
    anguilla: '安圭拉',
    montserrat: '蒙特塞拉特',
    guadeloupe: '瓜德羅普',
    martinique: '馬提尼克',
    netherlandsAntilles: '安的列斯',
    aruba: '阿魯巴',
    turksAndCaicos: '特克斯和凱科斯群島',
    caymanIslands: '開曼群島',
    bermuda: '百慕大',
    colombia: '哥倫比亞',
    venezuela: '委內瑞拉',
    guyana: '圭亞那',
    suriname: '蘇里南',
    ecuador: '厄瓜多爾',
    peru: '秘魯',
    bolivia: '玻利維亞',
    brazil: '巴西',
    chile: '智利',
    argentina: '阿根廷',
    uruguay: '烏拉圭',
    paraguay: '巴拉圭',
    italy: '意大利',
    vatican: '梵蒂岡',
    sanMarino: '聖馬力諾',
    malta: '馬耳他',
    spain: '西班牙',
    portugal: '葡萄牙',
    andorra: '安道爾',
    egypt: '埃及',
    tunisia: '突尼斯',
    algeria: '阿爾及利亞',
    morocco: '摩洛哥',
    azores: '亞速爾群島（葡）',
    madeiraIslands: '馬德拉群島（葡）',
    ethiopia: '衣索比亞',
    djibouti: '吉布提',
    kenya: '肯亞',
    tanzania: '坦桑尼亞',
    uganda: '烏干達',
    rwanda: '盧旺達',
    burundi: '蒲隆地',
    seychelles: '塞舌爾',
    nigeria: '奈及利亞',
    ukraine: '烏克蘭',
    pakistanNew: '巴基斯坦',
    iran: '伊朗',
    unitedStates: '美國',
    canada: '加拿大',
    southKorea: '南韓',
    northKorea: '北韓',
  },
  fundsSourceList: {
    jobIncome: '工作收入',
    heritage: '遺產',
    savingsInvestment: '儲蓄及投資',
    other: '其他',
  },
  incomeList: {
    level1: '少於$25,000',
    level2: '$25,000 - $49,999',
    level3: '$50,000 - $99,999',
    level4: '$100,000 - $249,999',
    level5: '$250,000 - $1,000,000',
    level6: '多於$1,000,000',
  },
  industryList: {
    insurance: '保險',
    law: '法律',
    engineering: '工程建築',
    internet: '互聯網',
    advertising: '廣告公關',
    aviation: '航空',
    finance: '金融會計',
    construction: '建造培訓',
    banking: '金融服務',
    tourism: '旅遊',
    logistics: '物流運輸',
    healthcare: '醫護服務',
    media: '藝術娛樂媒體',
    government: '政府軍事',
    manufacturing: '製造生產',
    it: '資訊科技',
  },
  invTargetList: {
    shortTerm: '中短期投資',
    hedging: '對沖',
    longTerm: '長線交易',
    diversified: '多元化投資',
  },
  sexList: {
    male: '男',
    female: '女',
  },
  workList: {
    employed: '全職',
    partTime: '兼職',
    selfEmployed: '自雇',
    retired: '已退休',
    student: '學生',
    unemployed: '失業',
  },
  'more_links': '更多鏈接',
  'direct_link': '直客鏈接',
  'copy_link': '複製鏈接',
  'copy_content_to_clipboard': '複製內容到剪貼板',
  'edit_link_settings': '修改返佣規則',
  'view_qr_code': '查看二維碼',
  'view_rebate_rules': '查看返佣規則',
  'max_two_decimal_places': '最多允許兩位小數',
  'max_four_decimal_places': '最多允許四位小數',
  'only_integers_allowed': '只能輸入整數',
  'max_one_decimal_place': '最多允許一位小數'
}
